var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Great! Your friend "+_vm._s(_vm.notification.relations.referee.first_name)+" has registered with MySwitchPro! ")])}
var staticRenderFns = []

export { render, staticRenderFns }